
import React, { useCallback, useMemo } from "react";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import { useViewport } from 'components/general/useViewPort'
import NotAvailable from "components/common/NotAvailable";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import TableExpanded from "../teamEvent/TableExpanded";
import TableColumns from "../teamEvent/Columns";


const getConfiguration = ({ data, breakPoint, resultStatus, scheduleStatus }) => {
    let configuration = {
        caption: null,
        sortBy: [],
        columns: [],
        hiddenColumns: []
    };
    configuration.caption = <CaptionTable
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />
    configuration.sortBy = [{ id: 'Rank', desc: false }];

    configuration.columns = TableColumns()

    return configuration;
}



const MpnTeamEvent = ({ data }) => {
    const { breakPoint } = useViewport();
    const resultStatus = data?.cumulativeResults?.status?.code;
    const scheduleStatus = data?.cumulativeResults?.schedule?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    const configEvent = useMemo(() => getConfiguration({
        data: data,
        breakPoint: breakPoint,
        resultStatus: resultStatus,
        scheduleStatus: scheduleStatus
    }), [resultStatus, breakPoint, data]);

    const renderRowSubComponent = useCallback(({ row }) => {
        let componentExpanded = (<TableExpanded row={row?.original} isTeamEvent={true}/>)
        return (
          <LoaderSubComponent component={componentExpanded} />
        )
      }, []);

    if (!data?.cumulativeResults?.results) { return <NotAvailable /> }

    return (
        <>
            < MirsTable
                data={data?.cumulativeResults?.results}
                columns={configEvent.columns}
                sortable={false}
                //Key by row necesary in order to no paint innecesary
                keyRow='participant-code'
                //Component caption
                caption={configEvent.caption}
                //Columns to hidde 
                hiddenColumns={configEvent.hiddenColumns}
                //When show tble is sorted by 
                initialSortBy={configEvent.sortBy}
                // initialSortBy={[{ id: 'StartOrder', desc: false }]}
                id={`mirs-table-result-${rsc}`}
                renderRowSubComponent={renderRowSubComponent}
                showNavExtendedData={true}
                hasRelatedTimeline={true}
            //colIndex={2}
            />
        </>
    );
};

export default MpnTeamEvent;
